import { DateTime } from '@easepick/datetime';
import { easepick } from "@easepick/bundle"
import { RangePlugin } from '@easepick/range-plugin';
import { PresetPlugin } from "@easepick/bundle";
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="date-picker"
export default class extends Controller {
  static values = { schoolYearStartDate: Number }
  
  connect() {
    const date = new DateTime();

    const thisSchoolYear = () => {

      const d1 = new DateTime(this.schoolYearStartDateValue);
      const d2 = date.clone();
      return [d1, new DateTime(d2)];
    }

    const picker = new easepick.create({
      element: this.element,
      css: [
        "https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css",
        'https://cdn.jsdelivr.net/npm/@easepick/range-plugin@1.2.1/dist/index.css',
      ],
      zIndex: 10,
      format: "MM/DD/YYYY",
      plugins: [RangePlugin, PresetPlugin],
      PresetPlugin: {
        customPreset: {
          'Today': [date.clone(), date.clone()],
          'Last 7 days': [date.clone().subtract(6, 'day'), date.clone()],
          'Last 30 days': [date.clone().subtract(29, 'day'), date.clone()],
          'Last 90 days': [date.clone().subtract(89, 'day'), date.clone()],
          'This school year': thisSchoolYear(),
        }
      }
    })
    const _this = this
    picker.on('select', () => {
      _this.element.form.requestSubmit()
    });
  }
}
